class CatalogApi {
  constructor (ctx) {
    this.ctx = ctx
  }
  
  getGlovers = async () => {
    const res = await this.ctx.get('/catalog/glovers/')
    
    return res.data
  }

  getGlueTapeCalc = async (params) => {
    const res = await this.ctx.get('/catalog/glue_tape_calc/get_calculator_data/',params)
    
    return res.data
  }

  getGlueTapeLogoCalc = async (params) => {
    const res = await this.ctx.get('/catalog/glue_tape_logo_calc/get_calculator_data/',params)
    
    return res.data
  }
  
  getPackageCalc = async (params) => {
    const res = await this.ctx.get('/catalog/package_calc/get_calculator_data/',params)
    
    return res.data
  }

  getPackageTShirtCalc = async (params) => {
    const res = await this.ctx.get('/catalog/package_t_shirt_calc/get_calculator_data/',params)
    
    return res.data
  }

  getPackageZipLockCalc = async (params) => {
    const res = await this.ctx.get('/catalog/package_zip_lock_calc/get_calculator_data/',params)
    
    return res.data
  }

  getPeFilmCalc = async (params) => {
    const res = await this.ctx.get('/catalog/pe_film_calc/get_calculator_data/',params)
    
    return res.data
  }
  getPpBagCalc = async (params) => {
    const res = await this.ctx.get('/catalog/pp_bag_calc/get_calculator_data/',params)
    
    return res.data
  }

  getSpecialTapeCalc = async (params) => {
    const res = await this.ctx.get('/catalog/special_tape_calc/get_calculator_data/',params)
    
    return res.data
  }

  getStretchTapeCalc = async (params) => {
    const res = await this.ctx.get('/catalog/stretch_tape_calc/get_calculator_data/',params)
    
    return res.data
  }

  getTapeCalc = async (params) => {
    const res = await this.ctx.get('/catalog/tape_calc/get_calculator_data/',params)
    
    return res.data
  }

  getTermoFilmPofCalc = async (params) => {
    const res = await this.ctx.get('/catalog/termo_film_pof_calc/get_calculator_data/',params)
    
    return res.data
  }

  getTermoFilmPvcCalc = async (params) => {
    const res = await this.ctx.get('/catalog/termo_film_pvc_calc/get_calculator_data/',params)
    
    return res.data
  }

  getTermoFilmPvdCalc = async (params) => {
    const res = await this.ctx.get('/catalog/termo_film_pvd_calc/get_calculator_data/',params)
    
    return res.data
  }

  getTrashBagCalc = async (params) => {
    const res = await this.ctx.get('/catalog/trash_bag_calc/get_calculator_data/',params)
    
    return res.data
  }

  getVppCalc = async (params) => {
    const res = await this.ctx.get('/catalog/vpp_calc/get_calculator_data/',params)
    
    return res.data
  }

  getCatalogProducts = async (params={}) => {
    const res = await this.ctx.get('/catalog/product/', params)
    
    return res.data
  }
  
}

export default CatalogApi
